<template>
    <md-button
        v-if="!isReadOnlyUser"
        title="Approve invoice"
        class="md-success md-just-icon md-round"
        @click.stop="handleApproveInvoice()"
    >
        <md-icon>thumb_up</md-icon>
    </md-button>
</template>

<script>
import { mapGetters } from 'vuex';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { handleRequests, showErrorMessage } from '@/helpers';

export default {
    name: 'ApproveInvoiceButton',
    props: {
        invoiceId: {
            type: [Number, String],
            default: () => null
        },
        isBulk: {
            type: Boolean,
            default: false
        },
        bulkTeamMemberInvoiceIds: {
            type: Array,
            default: () => []
        }
    },
    mixins: [GeneralMixin],
    computed: {
        ...mapGetters({
            isReadOnlyUser: 'user/isReadOnlyUser'
        })
    },
    methods: {
        handleApproveInvoice() {
            let message = 'Are you sure you want to approve this invoice?';

            if (this.isBulk) {
                message = 'Are you sure you want to approve these invoices?';
            }

            this.$messageBox
                .show({
                    class: 'sm-modal-container',
                    title: 'Approve Invoice',
                    body: message,
                    buttons: ['Confirm', 'Cancel']
                })
                .then(async (response) => {
                    if (response.toLowerCase() === 'confirm') {
                        if (this.isBulk) {
                            await this.handleBulkApprove();
                        } else {
                            await this.handleConfirmApprove();
                        }
                    }
                });
        },
        async handleConfirmApprove() {
            if (this.invoiceId == null) {
                showErrorMessage(this, 'No invoice selected');
                return;
            }

            this.$_handleLoaderState(true, 'APPROVING...');
            const payload = {
                method: 'post'
            };
            const api = `/api/team-member-invoices/${this.invoiceId}/approve`;

            try {
                await handleRequests(api, payload);
                this.$notifySuccess('Invoice was approved!');
                this.$emit('invoiceApproved', { result: true, invoiceId: this.invoiceId });
            } catch (e) {
                const message = 'Error in approving the invoice.';
                showErrorMessage(this, message, e);
            }
            this.$_handleLoaderState(false);
        },
        async handleBulkApprove() {
            if (this.bulkTeamMemberInvoiceIds.length === 0) {
                showErrorMessage(this, 'No draft invoices selected');
                return;
            }

            this.$_handleLoaderState(true, 'APPROVING...');
            const payload = {
                method: 'post',
                data: this.bulkTeamMemberInvoiceIds
            };
            const api = `/api/team-member-invoices/bulk/approve`;

            try {
                await handleRequests(api, payload);
                this.$notify({
                    message: 'Invoices were successfully approved!',
                    type: 'success'
                });
                this.$emit('invoiceBulkApprove', { result: true, ids: this.bulkTeamMemberInvoiceIds });
            } catch (e) {
                const message = 'Error in approving the invoices';
                showErrorMessage(this, message, e);
                this.$emit('invoiceBulkApprove', { result: false, ids: this.bulkTeamMemberInvoiceIds });
            }
            this.$_handleLoaderState(false);
        }
    }
};
</script>

<style lang="scss" scoped></style>
